import { fromJS } from 'immutable';
import * as ReducerActions from './actions';

const initialState = fromJS({
    data: {
        localidadesEntrega: [],
        localidadEntregaSeleccionada: null,
        loading: false,
        error: null,
    }
});

export default function localidadesEntregaReducer(state = initialState, action) {
    if (action.type === ReducerActions.SET_LOCALIDADES_ENTREGA) {
        return state.setIn(["data", "localidadesEntrega"], action.payload);
    }

    if (action.type === ReducerActions.SET_LOCALIDAD_ENTREGA) {
        return state.setIn(["data", "localidadEntregaSeleccionada"], action.payload);
    }

    return state;
}